import { T } from '@tolgee/react';

export const RequestCouldntBeCompletedToasterMessage = () => {
  return <T keyName="errors.request_couldnt_be_completed" />;
};
